<div class="tt-export-dialog_content">
  <tt-banner [message]="translationPrefix + '.BetaNotice' | transloco" [type]="'warning'" />
  @if (data.hasWorkflow) {
    <tt-banner [message]="translationPrefix + '.WorkflowNotice' | transloco" [type]="'warning'" />
  }

  @if (isGenerating()) {
    <div class="tt-export-dialog_generating">
      <mat-spinner diameter="40" />
      <p>{{ translationPrefix + '.Generating' | transloco }}</p>
    </div>
  } @else if (error()) {
    <div class="tt-export-dialog_error">
      <mat-icon color="warn" [icon]="'error'" [iconSize]="24" />
      <p>{{ error() }}</p>
    </div>
  } @else if (blob()) {
    <div class="tt-export-dialog_success">
      <mat-icon color="primary" [icon]="'check_circle'" [iconSize]="24" />
      <p>{{ translationPrefix + '.Ready' | transloco }}</p>
    </div>
  }
</div>

<div class="tt-export-dialog_footer">
  @if (blob()) {
    <button ttButton variant="primary" (click)="downloadExport()">
      <mat-icon [icon]="'download'" [iconSize]="16" />
      <span>{{ translationPrefix + '.Download' | transloco }}</span>
    </button>
  }
  <button ttButton variant="secondary" (click)="onClose()">
    <span>{{ 'Close' | transloco }}</span>
  </button>
</div>
